import { useCallback } from 'react';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { fireTrackAnalytics } from '@atlassian/analytics-bridge';
import { downloadFile, useFormIndexActions } from '@atlassian/proforma-form-system';
import { Action, ActionSubject } from '@atlassian/proforma-utils/analytics';

const getXlsxDownloadUrl = (issueId: number, formId: number) =>
	`/api/1/issues/${issueId}/forms/${formId}/spreadsheet`;
const getPdfDownloadUrl = (issueId: number, formId: number) =>
	`/api/1/issues/${issueId}/forms/${formId}/pdf`;

export const useDownloadForm = (
	proformaUrl: string,
	issueId: number,
	defaultFilenameKey: string,
	formType: 'pdf' | 'xlsx',
) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const { reportError } = useFormIndexActions();

	const handleDownloadForm = useCallback(
		async (formId: number, formName?: string): Promise<void> => {
			let fileUrl = '';

			switch (formType) {
				case 'pdf':
					fileUrl = getPdfDownloadUrl(issueId, formId);
					break;
				case 'xlsx':
					fileUrl = getXlsxDownloadUrl(issueId, formId);
					break;
				default:
					break;
			}

			try {
				await downloadFile(
					proformaUrl + fileUrl,
					`${formName || 'Proforma'}-${defaultFilenameKey}.${formType}`,
					formType,
				);

				fireTrackAnalytics(createAnalyticsEvent({}), `${ActionSubject.FORM} ${Action.DOWNLOADED}`, {
					formId,
					formType,
				});
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
			} catch (error: any) {
				reportError(error, { id: 'downloadForm', attributes: { formId, formType } });
				return Promise.reject(error);
			}
		},
		[formType, proformaUrl, defaultFilenameKey, issueId, createAnalyticsEvent, reportError],
	);

	return handleDownloadForm;
};
